import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SERVICE_MODES = ["Local On-Site Dispatch", "Live Remote Session", "Small Office Maintenance"];

const empty = { full_name: "", contact: "", printer_model: "", service_mode: SERVICE_MODES[0], issue: "" };

export default function ContactForm() {
  const [form, setForm] = useState(empty);
  const [submitting, setSubmitting] = useState(false);

  const update = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    try {
      await axios.post(`${API}/enquiries`, form);
      toast.success("Request received — an independent technician will reach out shortly.");
      setForm(empty);
    } catch (err) {
      toast.error("Could not submit your request. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  const fieldCls =
    "w-full p-3 border-2 border-poster-border bg-white text-sm text-poster-ink focus:outline-none focus:border-poster-accent transition-colors";
  const labelCls = "block text-xs font-mono-lbl uppercase text-slate-600 mb-1 font-bold";

  return (
    <form data-testid="contact-form" className="space-y-4" onSubmit={onSubmit}>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className={labelCls} htmlFor="full_name">Full Name</label>
          <input
            id="full_name"
            data-testid="contact-name-input"
            type="text"
            required
            className={fieldCls}
            placeholder="e.g. Alex Morgan"
            value={form.full_name}
            onChange={update("full_name")}
          />
        </div>
        <div>
          <label className={labelCls} htmlFor="contact">Phone or Email</label>
          <input
            id="contact"
            data-testid="contact-contact-input"
            type="text"
            required
            className={fieldCls}
            placeholder="alex@business.com"
            value={form.contact}
            onChange={update("contact")}
          />
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className={labelCls} htmlFor="printer_model">Printer Model</label>
          <input
            id="printer_model"
            data-testid="contact-model-input"
            type="text"
            className={fieldCls}
            placeholder="e.g. PIXMA TR8620 / MAXIFY MB5420"
            value={form.printer_model}
            onChange={update("printer_model")}
          />
        </div>
        <div>
          <label className={labelCls} htmlFor="service_mode">Service Mode</label>
          <select
            id="service_mode"
            data-testid="contact-mode-select"
            className={fieldCls}
            value={form.service_mode}
            onChange={update("service_mode")}
          >
            {SERVICE_MODES.map((m) => (
              <option key={m}>{m}</option>
            ))}
          </select>
        </div>
      </div>
      <div>
        <label className={labelCls} htmlFor="issue">Issue Description</label>
        <textarea
          id="issue"
          data-testid="contact-issue-textarea"
          rows="3"
          required
          className={fieldCls}
          placeholder="Describe paper jam codes, print quality issues, or connectivity errors..."
          value={form.issue}
          onChange={update("issue")}
        />
      </div>
      <button
        type="submit"
        data-testid="contact-submit-button"
        disabled={submitting}
        className="w-full py-4 bg-poster-accent hover:bg-sky-700 disabled:opacity-60 text-white font-poster text-xl uppercase tracking-wider transition-colors shadow-md"
      >
        {submitting ? "Submitting..." : "Submit For Immediate Response"}
      </button>
    </form>
  );
}
